module.exports = __webpack_public_path__ + "static/animation-services-user-bbfd8e532c70fd0261d6a2f6dec2233a.png";